// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ePa1","content":"styles_content__35FpR"};